import { applicationUrl } from "@constants";
import { getIsStagingEnvironment } from "@utils";

export function getEncodedUrl(string: string) {
  const url = new URL(string);
  const encodedParameters = new URLSearchParams();

  for (const [key, value] of url.searchParams.entries()) {
    const encodedKey = key === decodeURIComponent(key) ? encodeURIComponent(key) : key;
    const encodedValue = value === decodeURIComponent(value) ? encodeURIComponent(value) : value;

    encodedParameters.append(encodedKey, encodedValue);
  }

  const encodedUrl = encodedParameters.toString()
    ? `${url.origin}${url.pathname}?${encodedParameters.toString()}`
    : `${url.origin}${url.pathname}`;

  return encodedUrl;
}

export type FileDownloadType = "preview" | "download";

export const getFileDownloadUrl = (documentId: number | string, downloadType: FileDownloadType = "download") =>
  `${applicationUrl}/api/documents/${documentId}/${downloadType}`;

export function getApplicationSpaBackendUrl() {
  // we don't have .env variable for staging SPA backend URL, so we hardcode it for now
  if (getIsStagingEnvironment()) {
    return "https://app.staging.testaviva.dk/v2/api";
  }

  return import.meta.env.VITE_APPLICATION_SPA_BACKEND_URL ?? "";
}

export function getLawdocsUrl() {
  // we don't have .env variable for staging SPA backend URL, so we hardcode it for now
  if (getIsStagingEnvironment()) {
    return "https://lawdocs.staging.testaviva.dk";
  }

  return import.meta.env.VITE_LAWDOCS_URL ?? "";
}
